import { AxiosError } from 'axios';
import i18n from '@/i18n';

export type ApiErrorCode =
    | 'STORAGE_GENERATION_MISMATCH'
    | 'PROJECT_INVALID_LAYERS'
    | 'STORAGE_OBJECT_NOT_FOUND'
    | 'STORAGE_LOCK_TIMEOUT'
    | 'STORAGE_BACKEND_UNAVAILABLE'
    | string;

export class ApiError extends Error {
    code?: ApiErrorCode;
    status?: number;
    details?: Record<string, unknown>;

    constructor(message: string, opts: { code?: ApiErrorCode; status?: number; details?: Record<string, unknown> } = {}) {
        super(message);
        this.name = 'ApiError';
        this.code = opts.code;
        this.status = opts.status;
        this.details = opts.details;
    }
}

export function throwApiError(error: unknown, fallback: string): never {
    if (error instanceof AxiosError) {
        const data = error.response?.data as any;
        const message = data?.message || data?.detail || fallback;
        throw new ApiError(message, {
            code: data?.error_code,
            status: error.response?.status,
            details: data?.details,
        });
    }
    if (error instanceof Error) throw error;
    throw new ApiError(fallback);
}

export async function withApiError<T>(fallbackKey: string, fn: () => Promise<T>): Promise<T> {
    try {
        return await fn();
    } catch (error) {
        throwApiError(error, i18n.t(fallbackKey));
    }
}
